export const capitalize = (text) => {
  const str = text.split(' ');
  let result = '';

  str.forEach(element => {
    const lower = element.toLowerCase();
    result = `${result} ${element.charAt(0).toUpperCase()}${lower.slice(1)}`;
  });

  return result.slice(1);
};

export const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2
})